import List from '../../components/List/List';
import { categories } from '../../utils/cardInfo';

const OrganizationsPage = () => {
  return (
    <List
      category={'organizations'}
      heading={'Organizations'}
      cardHeader={categories.organizations.cardHeader}
      icons={categories.organizations.icons}
      dotColor={categories.organizations.dotColor}
    />
  );
};

export default OrganizationsPage;
